import { Select } from 'foundations-components/transitional/components/Select';
import Skeleton from 'personalization-lib/components/shared/display/Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectSkeleton = props => /*#__PURE__*/_jsx(Select, Object.assign({
  minInlineSize: "200px",
  buttonUse: "tertiary-light",
  buttonSize: "small",
  disabled: true,
  valueRenderer: () => /*#__PURE__*/_jsx(Skeleton, {
    blockSize: "1em",
    borderRadius: "400",
    use: "on-dark"
  })
}, props));
export default SelectSkeleton;